<template>
    <div class="list-item">
        <div v-if="show" class="image"><img :src="img" alt="Imagem"></div>
        <div class="content">
            <header>
                <h4 v-html="title"></h4>
                <p>
                    por <span>{{categoria}}</span>, {{ date }}
                </p>
            </header>
            <div>
                <p v-html="text.substring(0,300)" v-if="text.length > 0"></p>
                <router-link :to="path" class="font-black italic text-black">
                    ...Leia mais
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "comments-list",
    props: {
        title: String,
        text: String,
        date: String,
        author: String,
        img: String,
        path: String,
        categoria: String
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        mostraImagem() {
          if (this.img === undefined) {
              return false
          }
          else {
              return true
          }
        },
    },
    mounted() {
        this.show = this.mostraImagem()
    }
}
</script>

<style scoped lang="scss">
.list-item {
    @apply border-light-gray border-b-2 py-6 flex items-start;
    @media(max-width: 414px) {
        @apply flex flex-col;
        header {
            @apply mt-4;
        }
    }
    @media(max-width: 768px) {
        @apply flex;
        header {
            @apply flex-col;
        }
        .image {
            @apply w-full;
        }
    }
    header {
        @apply flex justify-between mb-2;
        h4 {
            @apply font-medium text-xl;
        }
        span {
            @apply text-tertiary;
        }
    }
    p {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        @apply text-sm;
    }
    .image {
        width: 200px;
        height: auto;
        @apply mr-10 rounded-lg bg-primary;
        img{
            @apply rounded-lg w-full;
            height: 140px;
            object-fit: cover;
        }
    }
    .content {
        @apply w-full;
    }
}
</style>
